import { Route } from 'react-router-dom';
import { routes } from '../../utils/helpers/ApiClient';
import CMSWrapper from '../CMSWrapper';
import {
  ExternalPartnersEdit,
  ExternalUsersEdit,
  ExternalUsersPage,
  FijDetailPage,
  LogsPage,
  LogsDetail,
  PermissionsPage,
  RolesDetail,
  RolesPage,
  UserDetailPage,
  UserProfileEdit,
  UsersPage,
} from '../pages/CMSPages/index';
import React from 'react';
import { ExternalPartnersPage } from '../pages/PublicPages/index.jsx';
import HelpPage from '../pages/CMSPages/Help/HelpPage/HelpPage.jsx';
import HelpEdit from '../pages/CMSPages/Help/HelpEdit/HelpEdit.jsx';

const PortalAdministrationRoutes = () => (
  <>
    <Route
      path={routes.cmsPermissions}
      element={
        <CMSWrapper permissions={['permissions.index']}>
          <PermissionsPage />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsRoles}
      element={
        <CMSWrapper permissions={['roles.index']}>
          <RolesPage />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsRolesDetail}/:id`}
      element={
        <CMSWrapper permissions={['roles.show']}>
          <RolesDetail />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsLogs}
      element={
        <CMSWrapper permissions={['logs.index']}>
          <LogsPage />
        </CMSWrapper>
      }
    />

    <Route
      path={`${routes.cmsLogsDetail}/:id`}
      element={
        <CMSWrapper permissions={['logs.index']}>
          <LogsDetail />
        </CMSWrapper>
      }
    />

    <Route
      path={`${routes.cmsFijJobDetail}/:id`}
      element={
        <CMSWrapper>
          <FijDetailPage />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsUsers}
      element={
        <CMSWrapper permissions={['users.index']}>
          <UsersPage />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsUsersEdit}/:id`}
      element={
        <CMSWrapper permissions={['users.show']}>
          <UserDetailPage />
        </CMSWrapper>
      }
    />
    <Route
      path={`${routes.cmsUserProfileEdit}/:id`}
      element={
        <CMSWrapper permissions={['users.show']}>
          <UserProfileEdit />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsExternalUsers}
      element={
        <CMSWrapper permissions={['external-users.index']}>
          <ExternalUsersPage />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsExternalUsersCreate}
      element={
        <CMSWrapper permissions={['external-users.store']}>
          <ExternalUsersEdit mode={'create'} />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsExternalUsersEdit(':id')}
      element={
        <CMSWrapper permissions={['external-users.update']}>
          <ExternalUsersEdit mode={'edit'} />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsExternalPartners}
      element={
        <CMSWrapper permissions={['external-partners.index']}>
          <ExternalPartnersPage />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsExternalPartnersCreate}
      element={
        <CMSWrapper permissions={['external-partners.store']}>
          <ExternalPartnersEdit mode={'create'} />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsExternalPartnersEdit(':id')}
      element={
        <CMSWrapper permissions={['external-partners.show']}>
          <ExternalPartnersEdit mode={'edit'} />
        </CMSWrapper>
      }
    />

    <Route
      path={routes.cmsHelp}
      element={
        <CMSWrapper permissions={['help.index']}>
          <HelpPage />
        </CMSWrapper>
      }
    />
    <Route
      path={routes.cmsHelpCreate}
      element={
        <CMSWrapper permissions={['help.store']}>
          <HelpEdit mode={'create'} />
        </CMSWrapper>
      }
    />

    <Route
      path={`${routes.cmsHelpEdit}/:id`}
      element={
        <CMSWrapper permissions={['help.update']}>
          <HelpEdit mode={'edit'} />
        </CMSWrapper>
      }
    />

  </>
);

export default PortalAdministrationRoutes;
